import { Link } from 'react-router-dom';
import Seo from '../components/common/Seo';
import CategoryNav from '../components/common/CategoryNav';
import SearchBox from '../components/common/SearchBox';

/**
 * 404.
 *
 * noIndex so a mistyped URL never enters the index, and it offers search plus
 * category links — a dead end here is a lost reader and a wasted crawl.
 */
function NotFound() {
  return (
    <div className="container page notfound">
      <Seo title="Page not found" path="/404" noIndex />

      <p className="notfound-code" aria-hidden="true">
        404
      </p>
      <h1 className="page-title">This page doesn’t exist</h1>
      <p className="page-sub">
        The link may be broken, or the article may have moved. Try a search, or start from one of
        the sections below.
      </p>

      <SearchBox className="search-box-page" id="notfound-search" />

      <div className="notfound-actions">
        <Link className="btn btn-primary" to="/">
          Go to homepage
        </Link>
        <Link className="btn btn-ghost" to="/blogs">
          Browse all articles
        </Link>
      </div>

      <CategoryNav includeAll={false} ariaLabel="Browse by category" />
    </div>
  );
}

export default NotFound;
